
import PropTypes from 'prop-types';
import CustomText from '../atoms/custom-text.atom';

const InfoBox = ({
    icon,
    children,
    style,
    ...props
}) => {
    return (
        <div style={{...styles.container, ...style}} {...props}>
            {icon && (
                <div style={styles.iconContainer}>
                    {icon()}
                </div>
            )}
            <div style={styles.content}>
                {typeof children === 'string' ? (
                    <CustomText variant="body">
                        {children}
                    </CustomText>
                ) : children}
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '16px',
        padding: '24px',
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    content: {
        flex: 1,
    },
};

InfoBox.propTypes = {
    icon: PropTypes.func,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};

export default InfoBox; 